import React, { useEffect, useState } from "react";
import "../../CSS/Inscription.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import api from "../../components/api";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

const Inscription = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleNameChange = (e) => {
    const value = e.target.value;
    setUsername(value);
    setUsernameError(
      value.trim() === ""
        ? "Le nom est obligatoire."
        : value.length < 3
          ? "Le nom doit comporter au moins 3 caractères."
          : "",
    );
  };

  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setEmailError(
      !emailRegex.test(value) ? "Veuillez entrer un email valide." : "",
    );
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);

    // 1. On définit les critères
    const isLongEnough = value.length >= 6;
    const hasLetterAndDigit = /^(?=.*[A-Za-z])(?=.*\d)/.test(value);

    // 2. On gère les messages d'erreur de manière hiérarchique
    if (!value) {
      setPasswordError("Le mot de passe est requis.");
    } else if (!isLongEnough) {
      setPasswordError("Le mot de passe doit comporter au moins 6 caractères.");
    } else if (!hasLetterAndDigit) {
      setPasswordError(
        "Le mot de passe doit contenir au moins une lettre et un chiffre.",
      );
    } else {
      setPasswordError(""); // Tout est bon !
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);
    setConfirmPasswordError(
      value !== password ? "Les mots de passe ne correspondent pas." : "",
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!username || !email || !password || !confirmPassword) {
      alert("Veuillez remplir tous les champs");
      return;
    }

    const signUpData = {
      username: username,
      email: email,
      password: password,
      confirmPassword: confirmPassword,
    };

    setLoading(true);

    api
      .post("/inscription", signUpData)
      .then((response) => {
        setLoading(false);
        alert("Inscription réussie");
        navigate("/connexion");
      })
      .catch((err) => {
        setLoading(false);
        alert("Erreur lors de l'inscription");
      });
  };

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light p-3 p-lg-5">
      <div className="container">
        <div className="row g-0 shadow-lg rounded overflow-hidden">
          {/* BLOC FORMULAIRE D'INSCRIPTION */}
          <div className="col-12 col-lg-6 bg-white p-4 p-md-5 d-flex flex-column justify-content-center">
            <Link
              to="/"
              className="text-decoration-none text-muted mb-4 d-inline-flex align-items-center link-hover"
            >
              <i className="bi bi-arrow-left me-2"></i>{" "}
              {/* Si vous utilisez Bootstrap Icons */}
              ← Retour à l'accueil
            </Link>
            <h2
              className="text-center fw-bold mb-4"
              style={{ color: "#f5721e" }}
            >
              Inscription
            </h2>

            <form onSubmit={handleSubmit}>
              {/* Champ Nom */}
              <div className="mb-3">
                <label className="form-label fw-semibold">Nom</label>
                <input
                  type="text"
                  name="username"
                  className={`form-control form-control-lg ${usernameError ? "is-invalid" : ""}`}
                  placeholder="Votre nom complet"
                  value={username}
                  onChange={handleNameChange}
                />
                {usernameError && (
                  <div className="invalid-feedback">{usernameError}</div>
                )}
              </div>

              {/* Champ Email */}
              <div className="mb-3">
                <label className="form-label fw-semibold">Email</label>
                <input
                  type="email"
                  name="email"
                  className={`form-control form-control-lg ${emailError ? "is-invalid" : ""}`}
                  placeholder="exemple@mail.com"
                  value={email}
                  onChange={handleEmailChange}
                />
                {emailError && (
                  <div className="invalid-feedback">{emailError}</div>
                )}
              </div>

              {/* Champ Mot de passe */}
              <div className="mb-3 position-relative">
                <label className="form-label fw-semibold">Mot de passe</label>
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className={`form-control form-control-lg ${passwordError ? "is-invalid" : ""}`}
                    placeholder="Créer un mot de passe"
                    value={password}
                    onChange={handlePasswordChange}
                  />
                  <span
                    className="input-group-text bg-transparent border-start-0"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <FontAwesomeIcon
                      icon={showPassword ? faEye : faEyeSlash}
                      className="text-muted"
                    />
                  </span>
                  {passwordError && (
                    <div className="invalid-feedback d-block">
                      {passwordError}
                    </div>
                  )}
                </div>
              </div>

              {/* Confirmation Mot de passe */}
              <div className="mb-4 position-relative">
                <label className="form-label fw-semibold">
                  Confirmer le mot de passe
                </label>
                <div className="input-group">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    className={`form-control form-control-lg ${confirmPasswordError ? "is-invalid" : ""}`}
                    placeholder="Répétez le mot de passe"
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                  />
                  <span
                    className="input-group-text bg-transparent border-start-0"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    <FontAwesomeIcon
                      icon={showConfirmPassword ? faEye : faEyeSlash}
                      className="text-muted"
                    />
                  </span>
                  {confirmPasswordError && (
                    <div className="invalid-feedback d-block">
                      {confirmPasswordError}
                    </div>
                  )}
                </div>
              </div>

              {/* Bouton Action */}
              {loading ? (
                <button
                  className="btn btn-warning btn-lg w-100 shadow-sm"
                  type="button"
                  disabled
                >
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Création du compte...
                </button>
              ) : (
                <button
                  type="submit"
                  className="btn btn-lg w-100 text-white shadow-sm mb-3"
                  style={{ backgroundColor: "#f5721e", border: "none" }}
                >
                  S'inscrire
                </button>
              )}
            </form>

            <div className="text-center mt-2 text-muted">
              Avez-vous déjà un compte ?{" "}
              <Link
                to={"/connexion"}
                className="text-decoration-none fw-bold"
                style={{ color: "#f5721e" }}
              >
                Connectez-vous ici
              </Link>
            </div>
          </div>

          {/* BLOC IMAGE */}
          <div className="col-lg-6 d-none d-lg-block p-0">
            <img
              src="/images/COMMANDO.png"
              className="w-100 h-100"
              alt="Illustration inscription"
              style={{ objectFit: "cover", minHeight: "600px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Inscription;
